// <s-progressive-discount> (snippets/progressive-discount.liquid): collapsible
// table of quantity tiers ([data-tier-min] rows). When the size grid's total
// changes ("size-matrix:total" { total }), the row of the highest tier reached
// gets data-active, and the table opens the first time a tier is reached.
class SProgressiveDiscount extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    document.addEventListener('size-matrix:total', (event) => {
      this.#highlight(Number(event.detail?.total) || 0);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #highlight(total) {
    const rows = [...this.querySelectorAll('[data-tier-min]')];
    const reached = rows
      .filter((row) => Number(row.dataset.tierMin) <= total)
      .pop();

    for (const row of rows) {
      row.toggleAttribute('data-active', row === reached);
    }

    const details = this.querySelector('details');
    if (reached && details && !details.open) details.open = true;
  }
}

if (!customElements.get('s-progressive-discount')) {
  customElements.define('s-progressive-discount', SProgressiveDiscount);
}
